export default class Loader {

    constructor() {
		}

    init() {
			// Helper function
			let domReady = (cb) => {
				document.readyState === 'interactive' || document.readyState === 'complete'
					? cb()
					: document.addEventListener('DOMContentLoaded', cb);
			};

			domReady( () => {
				// Display body when DOM is loaded
				document.body.classList.add('is-loaded');
			})

    }

}